import axios from '../../plugins/axios'

export default {
  async getUniverseStatuses (universeId, params) {
    const result = await axios.get('universe-statuses', { params })
    return result.data
  }
}
